import { render, staticRenderFns } from "./PersonUnlinkButton.vue?vue&type=template&id=3871855e&scoped=true"
import script from "./PersonUnlinkButton.vue?vue&type=script&lang=js"
export * from "./PersonUnlinkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871855e",
  null
  
)

export default component.exports